import { observer } from 'mobx-react';
import { IValidationGroup } from '../../../../../../../hooks/validation-group/validation-group-hook';
import ApiKeyField from '../fields/api-key-field/api-key-field';
import { FormFieldLine } from '../../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../../components/inputs/input/input';
import ApiSecretField from '../fields/api-secret-field/api-secret-field';
import CustomerNumberField from '../fields/customer-number-field/customer-number-field';
import MondialRelayCredentialsStore from '../../../../stores/credentials/shipping/mondial-relay-credentials-store';

interface IProps {
    credentialsStore: MondialRelayCredentialsStore,
    vGroup: IValidationGroup,
}

const MondialRelayCredentials: React.FC<IProps> = observer(({
    credentialsStore,
    vGroup,
}) => {
    return (
        <>
            <ApiKeyField
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
                label='Dual Carrier API Username'
                note='Your Mondial Relay Email'
            />
            <ApiSecretField
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
                label='Dual Carrier API Password'
                note='Mondial Relay Dual Carrier API Password'
            />
            <CustomerNumberField 
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
                label='Dual Carrier Customer ID'
                note='Mondial Relay Dual Carrier API Сustomer ID'
            />
            <FormFieldLine
                required
                label='WebService API Brand ID'
                key='username'
                note='Mondial Relay WebService API Brand ID'
            >
                <Input
                    value={credentialsStore.username}
                    onChange={credentialsStore.setUsername}
                    validationGroup={vGroup}
                    type='password'
                    autoComplete='new-password'
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='WebService API Private Key'
                key='order-channel-id'
                note='Mondial Relay WebService API Private Key'
            >
                <Input
                    value={credentialsStore.orderChannelId}
                    onChange={credentialsStore.setOrderChannelId}
                    validationGroup={vGroup}
                    type='password'
                    autoComplete='new-password'
                    required
                />
            </FormFieldLine>
        </>
    );
});

export default MondialRelayCredentials;
